import React from 'react';
import { Button, BackButton, ResultValue, PrintButton } from '../Components/Simple';
import { SNF as modelType } from '../Constants/modelTypes';
import { PricingErrors, ServiceLineItems, BasicInformation, ClaimDetails, FactorAndAdjustments } from '../Components/Combined/Results';
import { formatStringAsCurrency, cleanUpNumberString, formatDateString } from '../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats';
import { useNavigate, useLocation } from 'react-router-dom';
import usePrintOrientation from '../Hooks/usePrintOrientation';
import Protect from '../Components/Combined/Protect';
import { HIDE } from '../Constants/protectionBehaviors';
import { EOB_VIEW } from '../Constants/moduleNames';
import { enableEOB } from '../Utils/features';

export default function SNFResult() {
    const [_orientation, _setOrientation] = usePrintOrientation('landscape');
    const navigate = useNavigate();
    const location = useLocation();
    const { result, fiscalYear, billedAmountTotal } = location.state;

    const processedDate = new Date();

    const handleNavigateToEOBGenerator = () => {
        const admitDate = formatDateString(result.admitDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
        const dischargeDate = admitDate && formatDateString(result.dischargeDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
        navigate('/EOB', {
            state: {
                processedDate,
                pricerType: modelType,
                lines: [{
                    dateOfService: dischargeDate && `${admitDate} - ${dischargeDate}`,
                    serviceCode: "",
                    serviceDescription: "Skilled Nursing Facility Services",
                    qty: "",
                    billedAmount: parseFloat(cleanUpNumberString(billedAmountTotal)) || 0,
                    allowedAmount: parseFloat(result.medicareAllowed) || 0,
                    initialMaxShiftAmount: 0
                }]
            }
        })
    }

    return (<div className="py-2">
        <div className="row g-0 sticky top border-bottom">
            <div className="row justify-content-between g-0">
                <div className="col-auto">
                    <PrintButton />
                </div>
                <div className="col-auto">
                    <Protect module={EOB_VIEW} behavior={HIDE} >
                        {enableEOB && <Button className="btn btn-success" onClick={handleNavigateToEOBGenerator} text="Generate EOB" />}
                    </Protect>
                </div>
                <div className="col-auto">
                    <BackButton />
                </div>
            </div>
            <div className="row my-2 g-0">
                <div className="col">
                    <h2>SNF Pricer - Pricing Outputs</h2>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <ResultValue label="Medicare Allowed Amount" value={formatStringAsCurrency(result.medicareAllowed)} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
            </div>
        </div>
        <PricingErrors result={result} />
        <div className="row my-2">
            <div className="col-md-6">
                <BasicInformation fiscalYear={fiscalYear} result={result} model={modelType} processedDate={processedDate} />
            </div>
        </div>
        <div className="row my-2">
            <div className="col-md">
                <ClaimDetails result={result} model={modelType} />
            </div>
            <div className="col-md">
                <FactorAndAdjustments result={result} model={modelType} />
            </div>
        </div>
        <div className="page-break-here"></div>
        <div className="row my-2">
            <div className="col">
                <ServiceLineItems result={result} model={modelType} />
            </div>
        </div>
    </div>
    );
}
